import React from 'react';
import styles from './ExploreItem.module.css';

/**
 * Type definition for the Character object
 */
interface Character {
  id: string;
  username: string;
  display_name: string;
  tagline: string;
  icon: string;
}

/**
 * Props interface for the ExploreItem component
 */
interface ExploreItemProps {
  character: Character;
  onClick: (character: Character) => void;
}

/**
 * Shared component for displaying a character item in the explore view
 * Used by both mobile and desktop views
 */
const ExploreItem: React.FC<ExploreItemProps> = ({ character, onClick }) => {
  return (
    <div 
      className={styles.exploreItem}
      onClick={() => onClick(character)}
      role="button"
      tabIndex={0}
      aria-label={`View ${character.display_name}`}
    >
      <div className={styles.itemImage}>
        <img src={character.icon} alt={character.display_name} />
      </div>
      <div className={styles.itemContent}>
        <h3 className={styles.displayName}>{character.display_name}</h3>
        <p className={styles.tagline}>{character.tagline}</p>
      </div>
    </div>
  );
};

// Wrap with React.memo to prevent re-renders when props haven't changed
export default React.memo(ExploreItem); 